import type OlMap from 'ol/Map'
import { exportMapPng } from '../map/exportPng'
import type { Basemap } from '../map/mapInit'

/**
 * PNG export (PRD P1.5). An immediate action, not a tool: it has no panel to
 * unfold, so the toolbar hands it its own button to report progress on.
 */
export function runExport(button: HTMLButtonElement, map: OlMap, basemaps: Basemap[]): void {
  button.disabled = true
  button.textContent = 'Exporting…'
  const stamp = new Date().toISOString().slice(0, 10)
  exportMapPng(map, basemaps, `geoviewer-${stamp}.png`)
    .catch((err: unknown) => console.error('PNG export failed:', err))
    .finally(() => {
      button.disabled = false
      button.textContent = 'Export PNG'
    })
}
